import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { VoteStatus } from "../Deliberation/useVoteState";
import { getNbDecimal, roundDecimal } from "components/helper/numberHelper";

type Answer = {
    id: string;
    weight: number;
    disableOtherPropositionsIfSelected: boolean;
};

type Props = {
    participant: { displayName: string; weight: number };
    voteIsWithDistribution: boolean;
    participantVote: {
        voteStatus: string;
        answers: Array<Answer>;
    };
    isGroupedDeliberation?: boolean;
};

const ParticipantHeader = ({
    participant,
    voteIsWithDistribution,
    participantVote,
    isGroupedDeliberation,
}: Props) => {
    const { t } = useTranslation();

    const renderWeightSection = () => {
        const remainingWeight = participantVote.answers
            .map((answer) => answer.weight)
            .reduce(
                (prev, curr) =>
                    roundDecimal(prev - curr, getNbDecimal(participant.weight)),
                participant.weight,
            );

        return (
            <>
                <StyledNumberOfVoices>
                    {t("numberOfVote")}
                    {voteIsWithDistribution
                        ? remainingWeight.toString() + "/"
                        : null}
                    {participant.weight}
                </StyledNumberOfVoices>
                {voteIsWithDistribution && !isGroupedDeliberation ? (
                    participantVote.voteStatus === VoteStatus.Success ? (
                        <StyledSuccessVotedMessage>
                            {t(`sentSucceded.${window.env.REACT_APP_THEME}`)}
                        </StyledSuccessVotedMessage>
                    ) : null
                ) : null}
            </>
        );
    };

    return (
        <>
            {participant.weight > 1 ? (
                renderWeightSection()
            ) : participantVote.voteStatus === VoteStatus.Success ? (
                <StyledSuccessVotedMessage>
                    {t(`sentSucceded.${window.env.REACT_APP_THEME}`)}
                </StyledSuccessVotedMessage>
            ) : null}
        </>
    );
};

const StyledNumberOfVoices = styled.div`
    color: #626262;
    padding-bottom: 0.5rem;
    font-size: 14px;
`;

const StyledSuccessVotedMessage = styled.p`
    color: #60b860;
    margin: 0;
    font-size: 0.85rem;
`;

export default ParticipantHeader;
